import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Initialize Firebase Messaging
const messaging = getMessaging(app);

// VAPID Key for FCM
const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || "BAm-I8A8waCyIy5Is2ODswsypYvxzxi5RqL6x26U-lBh3T47W8BjQbhhKpN3wUx726QqURB2MUoDr93j4OLL5xY";

export { app, analytics, messaging, VAPID_KEY };
export { firebaseConfig };